// extracted by mini-css-extract-plugin
export default {"button":"styles_button__EsuRo","primary":"styles_primary__D7w-Q","secondary":"styles_secondary__B-QRX","buttonIcon":"styles_buttonIcon__ulVUQ"};